import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Savedata } from "./records";

const slice = createEntitySlice<Savedata>({ name: "roomSavedatas" });

export const reducer = slice.reducer;
export const actions = slice.actions;
